import React from 'react'
import { CallToAction } from 'components/Buttons/Buttons'
import { DataTablet } from 'components/Data/Data'

export default class Tablet extends React.Component {
    render() {
        const Data = DataTablet();
        return (
            <section className="category-section tablet decorative">

                <div className="centered">

                    <h3 className="section-title">{Data.tablet.categoryName}</h3>
                    <p className="section-description">{Data.tablet.categoryDescription}</p>

                    <div className="item">
                        <figure>
                            <img src={require("assets/images/tablet-hero-image.svg")} alt="Sketchize: Tablet Template" />
                            <span className="decorative-text left">SKETCH FOR<br />TABLET DEVICES</span>
                        </figure>
                        <h4 className="hero-item-title">{Data.tablet.title}</h4>
                        <p className="hero-item-description">{Data.tablet.description}</p>
                    </div>{/* .item */}

                    <CallToAction clickid="download-tablet" link={"https://github.com/selfishprimate/sketchize/raw/master/tools/zipped-files/tablet.zip"} content="DOWNLOAD MORE" />

                </div>{/* .centered */}
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/MainSections/Tablet/Tablet.js